import EditProjectContainer from "../containers/EditProjectContainer";

const EditProjectPage = () => {
  return (
    <EditProjectContainer />
  );
};

export default EditProjectPage;
